import type { AnyFormData, ArrayFieldAdapterProps, FieldPath, FieldValue } from "../types";
import { useFormContext } from "./contexts";

export const ArrayFieldAdapter = <
    TFormData extends AnyFormData,
    TName extends FieldPath<TFormData>,
    TItem = FieldValue<TFormData, TName> extends Array<infer Item> ? Item : never,
>({
    name,
    children,
}: ArrayFieldAdapterProps<TFormData, TName, TItem>) => {
    const form = useFormContext();

    return (
        <form.Field
            // @ts-ignore FIXME
            name={name as any}
            mode="array"
            children={(field) =>
                children({
                    // @ts-ignore
                    items: field.state.value,

                    // @ts-ignore
                    pushItem: (item) => field.pushValue(item),

                    // @ts-ignore
                    removeItem: (index) => field.removeValue(index),
                })
            }
        />
    );
};
